import { withTooltip } from '@consta/uikit/withTooltip'
import type { ComponentProps } from 'react'
import { forwardRef } from 'react'

const TooltipTargetImpl = forwardRef<HTMLSpanElement, ComponentProps<'span'>>(
  function TooltipTargetImpl(props, ref) {
    return <span ref={ref} {...props} />
  },
)

/**
 * Компонент нужен как обертка над выключаемым элементом
 * consta withTooltip навешивает слушатели событий на целевой элемент
 * В случае, если у целевого элемента [disabled=true], слушатели событий не срабатывают
 * Соответственно, тултип не появляется
 *
 * Для таких случаев, нужный компонент, который может быть выключен, следует обернуть в этот компонент
 */
export const TooltipTarget = withTooltip({
  mode: 'mouseover',
  appearTimeout: 500,
  direction: 'rightCenter',
  possibleDirections: ['rightCenter'],
})(TooltipTargetImpl)
